module.exports = __webpack_public_path__ + "static/media/1008543.3bb669b6.png";